module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/schedulebg-f6b1d07c06ca8afd2598ef2bd58400c1.png";